
import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { inCommands } from '../../../concepts/commands/CommandRegistry';
import { ObjectManager } from '../../../concepts/objects';
import { resolveSubject } from '../../canvas/commands/CommandUtil';
import { EditorSession } from '../../canvas/EditorSession';
import { RelativeTo } from '../../canvas/entities/Physical';
import { CardPile } from './CardPile';
import { Hand } from './Hand';
import { cardShuffle } from './HandCommands';
import { HandInfo } from './HandInfo';
import { ValueCard } from './ValueCard';

export const cardPileShuffle = defineCommand(
    'cardPileShuffle',
    'Card Pile: Shuffle',
    (cc, [targetId]: [string?]) => {

        const subject = resolveSubject(cc, targetId)?.as(CardPile);
        if (!subject) return;

        const at = subject.transform(RelativeTo.Model).apply(subject.layout.stack.center());
        const cards = subject.polarize(ValueCard);
        if (!cards.length) return;

        cc.dispatch(cardShuffle, [at, cards.map(x => x.id)]);
    }
);

export const cardPileDrawOne = defineCommand(
    'cardPileDrawOne',
    'Card Pile: Draw One',
    (cc, [targetId]: [string?]) => {

        const session = cc.resolve(EditorSession);
        const objects = cc.resolve(ObjectManager);

        const subject = resolveSubject(cc, targetId)?.as(CardPile);
        if (!subject) return;

        const [first] = subject.polarize(ValueCard).reverse();
        if (!first) return;

        const hand = objects.getMaybe(session.get(HandInfo).object, Hand);
        if (!hand) return;

        objects.update(() => {
            first.concealed = false;
            first.removeSelf();
            first.moveTo(0, 0);
            hand.add(first);
        });
    }
);

export const cardPileDrawAll = defineCommand(
    'cardPileDrawAll',
    'Card Pile: Draw All',
    (cc, [targetId]: [string?]) => {

        const session = cc.resolve(EditorSession);
        const objects = cc.resolve(ObjectManager);

        const subject = resolveSubject(cc, targetId)?.as(CardPile);
        if (!subject) return;

        const cards = subject.polarize(ValueCard).reverse();
        if (!cards.length) return;

        const hand = objects.getMaybe(session.get(HandInfo).object, Hand);
        if (!hand) return;

        objects.update(() => {
            for (const c of cards) {
                c.concealed = false;
                c.removeSelf();
                c.moveTo(0, 0);
                hand.add(c);
            }
        });
    }
);

export const inCardPileCommands = () => inCommands(
    cardPileShuffle,
);

